export default {
    user: {
        id: '',
        first_name: '',
        last_name: '',
        dob: '',
        token: '',
        role: '',
        balance: 0,
        address: null,
    },
    services: []
}
